import { Box, Button, Flex } from '@chakra-ui/react';
import { UseFilterConfigs } from '../useFilterConfigs';

interface FilterActionButtonsProps
  extends Pick<UseFilterConfigs, 'clearFilter' | 'applyFilter'> {
  applyFilter: () => void;
}
export default function ({
  clearFilter,
  applyFilter,
}: FilterActionButtonsProps) {
  return (
    <Flex justifyContent="space-between" my="1">
      <Button
        rounded="2xl"
        size="sm"
        padding="2px 15px"
        isDisabled={true}
        onClick={clearFilter}
      >
        Clear
      </Button>
      <Button
        colorScheme="green"
        ml="2"
        rounded="2xl"
        size="sm"
        padding="2px 15px"
        onClick={applyFilter}
      >
        Apply
      </Button>
    </Flex>
  );
}
